export default "__VITE_ASSET__BfiHaTpd__"